// src/components/ThreadView.jsx
import React, { useRef, useEffect } from 'react';

const HeartFilled = () => (
  <svg className="w-3 h-3" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 13 13">
    <path fill="#000" d="M12.188 5.18c0 3.554-5.271 6.432-5.496 6.55a.407.407 0 0 1-.384 0C6.083 11.612.813 8.734.813 5.18A3.152 3.152 0 0 1 3.96 2.03c1.049 0 1.967.451 2.539 1.213.572-.762 1.49-1.213 2.54-1.213a3.152 3.152 0 0 1 3.148 3.149Z"/>
  </svg>
);

export default function ThreadView({
  messages,
  loading,
  error,
  onLikeMessage,
  currentUserEmail,
  messageText,
  setMessageText,
  onSendMessage,
  sending
}) {
  const messagesEndRef = useRef(null);

  useEffect(() => {
    if (messagesEndRef.current) {
      messagesEndRef.current.scrollIntoView({ behavior: "auto" });
    }
  }, [messages]);

  return (
    <div className="h-full flex flex-col justify-between">
      {/* Messages Thread */}
      <div className="mb-4">
        {loading ? (
          <div className="text-center py-4 text-gray-500">Loading messages...</div>
        ) : error ? (
          <div className="text-center py-4 text-red-500">Error loading messages</div>
        ) : messages.length === 0 ? (
          <div className="text-sm text-gray-500">
            No messages yet. Start the conversation!
          </div>
        ) : (
          <div className="space-y-4">
            {messages.map((msg, idx) => (
              <div
                key={msg.id || idx}
                className={`p-4 relative rounded-lg ${msg.user === currentUserEmail ? 'bg-blue-100 ml-12' : 'bg-gray-100 mr-12'}`}
                onDoubleClick={() => onLikeMessage && onLikeMessage(idx)}
              >
                <div className="text-sm font-medium text-gray-700 mb-1 relative">
                  {msg.user === currentUserEmail ? 'You' : (msg.user || 'titled works')}
                </div>
                <div className="text-sm text-gray-900">{msg.message}</div>
                <div className={`flex items-start mt-2`}>
                  {msg.timestamp ? (
                    <div className="text-xs text-gray-500 mt-1">
                      {msg.timestamp?.toDate
                        ? msg.timestamp.toDate().toLocaleString()
                        : new Date(msg.timestamp).toLocaleString()
                      }
                    </div>
                  ) : null}
                </div>
                {msg.likes && (
                  <button
                    className={`flex items-center absolute bg-white h-6 w-6 flex justify-center items-center rounded-full bottom-[-10px] left-1`}
                    onClick={() => onLikeMessage && onLikeMessage(idx)}
                    aria-label="Like message"
                  ><HeartFilled />
                  </button>
                )}
              </div>
            ))}
            <div ref={messagesEndRef} />
          </div>
        )}
      </div>
      {/* Message Form */}
      <form onSubmit={onSendMessage} className="space-y-4">
        <div>
          <textarea
            value={messageText}
            onChange={e => setMessageText(e.target.value)}
            required
            rows={4}
            className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-black focus:border-transparent"
            placeholder="Type your reply…"
            disabled={sending}
          />
        </div>
        <div className="flex space-x-3 pb-6">
          <button
            type="submit"
            className="btn-primary flex-1 disabled:opacity-50"
            disabled={sending || !messageText.trim()}
          >
            {sending ? 'Sending...' : 'Send'}
          </button>
        </div>
      </form>
    </div>
  );
}